Namespace 'Models'

class Models.InstagramMessageContent
  @SUB_TYPE = 'ig-message'
  @ORIGIN = 'instagram-message-api'

  constructor: (message, author, isBrandContent, brandId, origin, parentId, link) ->
    @message = message
    @author = author
    @brandContent = isBrandContent
    @brandId = brandId
    @mainTextVisitor = new Models.Visitors.InstagramMessageMainTextVisitor
    @attachmentsVisitor = new Models.Visitors.InstagramMessageAttachmentsVisitor
    @origin = origin
    @parentId = parentId
    @link = link

  getGroupType: ->
    'instagram_private'

  getType: ->
    'instagram'

  getSubType: ->
    Models.InstagramMessageContent.SUB_TYPE

  getPrivacy: ->
    'private'

  getMainText: ->
    @message.accepts(@mainTextVisitor)
    @mainTextVisitor.mainText

  getContentId: ->
    @message.messageId

  isBrandContent: ->
    @brandContent

  hasUser: ->
    true

  hasProfile: ->
    true

  hasRelated: ->
    true

  hasContext: ->
    @getImmediateParentId()

  getAuthorId: ->
    @getAuthorUsername()

  getAuthorName: ->
    @author?.name

  getAuthorUsername: ->
    @author?.username

  getAvatar: ->
    @author?.profilePictureUrl

  getCreatedAt: ->
    Date.create(@message.timestamp)

  hasAttachments: ->
    @message.accepts(@attachmentsVisitor)
    @attachmentsVisitor.attachments.length == 0

  getAttachments: ->
    @message.accepts(@attachmentsVisitor)
    @attachmentsVisitor.attachments

  hasShares: ->
    false

  getOrigin: ->
    @origin

  getImmediateParentId: ->
    @parentId

  getRootParentId: ->
    @parentId

  getLink: ->
    @message.storyUrl

